<template>
  <LoadingSpinner v-if="!clubInfo"></LoadingSpinner>
  <div v-else class="mol-typical-page-container-20">
    <h1 class="text-center">Edit Oscar Pool</h1>

    <form class="mol-center-card-width create-club-form">

      <div class="club-pic">
        <EditableClubPicture :club=clubInfo.club :size="100" @image-updated="onClubPictureUpdated"></EditableClubPicture>
      </div>

      <div class="form-group">
        <label for="club-name">Oscar Pool Name</label>
        <input type="club-name" class="form-control" maxlength=64 id="club-name" v-model="updatedClubName" />
      </div>

      <div class="form-group">
        <label for="club-description">Oscar Pool Description <span class="char-limit-text" :style="`color: ${textLimitColor};`">(max {{clubDescriptionCharLimit}} characters)</span></label>
        <textarea class="form-control" id="club-description" rows="5" :maxlength="clubDescriptionCharLimit" v-model="updatedClubDescription"></textarea>
      </div>

      <div class="cancel-and-update-buttons text-center">
        <router-link class="btn btn-outline-secondary" :to="`/oscar-pool/${club_id}`">
          cancel
        </router-link>

        <button type="submit" class="btn btn-primary" ref="create-club-button" :class="{disabled: (updatingClub || !inputIsValid)}" @click.prevent="updateClub">
          <span v-if="updatingClub" class="spinner-border spinner-border-sm" role="status" ></span>
          <span v-if="updatingClub"> updating</span>
          <span v-else>update pool</span>
        </button>
      </div>
    </form>

    <div v-if="showDeleteClubButton" class="delete-club">
      <button  class="btn btn-danger" ref="delete-club-button" @click.prevent="deleteClub">
        <i class="fa fa-trash"></i> delete oscar pool
      </button>
      <p>As the owner of the pool, you're the only one who can delete it. Once you delete an Oscar Pool, it will disappear for all members but you.</p>
      <p>You'll have 24 hours to change your mind.</p>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import EditableClubPicture from "@/components/clubs/EditableClubPicture.vue";

export default {
  name: "EditClubPage",
  components: {EditableClubPicture, LoadingSpinner},
  props: ['club_id'],
  data() {
    return {
      clubInfo: null,
      updatedClubName: "",
      updatedClubDescription: "",
      updatedClubPic: null,
      clubDescriptionCharLimit: 1000,
      updatingClub: false
    }
  },
  computed: {
    textLimitColor() {
      return (
          (this.updatedClubDescription.length >= this.clubDescriptionCharLimit)? 'red' :
              (this.updatedClubDescription.length > (this.clubDescriptionCharLimit * 0.9))? 'goldenrod' :
                  'grey'
      ) ;
    },
    inputIsValid() {
      return (
          this.updatedClubName?.length
          //&& this.updatedClubDescription?.length
      );
    },
    showDeleteClubButton() {
      return this.clubInfo?.my_membership?.role === 'owner';
    }
  },
  async created() {
    return axios.get(`/api/club/${this.club_id}/club-info`)
        .then(response => {
          this.clubInfo = response.data;

          // if ( this.clubInfo.club.marked_for_deletion ) {
          //   this.clubInfo.club.marked_for_deletion = new Date(this.clubInfo.club.marked_for_deletion);
          //   this.updateTimeToLiveText();
          //   this.ttlUpdateInterval = setInterval(this.updateTimeToLiveText, 1000);
          // }

          // if I'm not an admin or owner of this club, reroute to the clubs page
          if ( (this.clubInfo.my_membership?.role !== 'admin') && (this.clubInfo.my_membership?.role !== 'owner') ) {
            this.$router.push({name: 'OscarPoolProfilePage', params: {club_id: this.club_id}});
          }
          this.updatedClubName = this.clubInfo.club.name;
          this.updatedClubDescription = this.clubInfo.club.description;
        })
        .catch(err => {
          console.log(err);
          this.$router.push({name: 'OscarPoolProfilePage', params: {club_id: this.club_id}});
        });
  },
  methods: {

    async askForConfirmation(_message) {
      return new Promise((resolve, reject) => {
        try {
          const confirmed = window.confirm(_message);
          resolve(confirmed);
        }
        catch(err) {
          reject(err);
        }
      });
    },

    async updateClub() {
      this.updatingClub = true;

      const form = new FormData();
      form.append('club_id', this.club_id);
      form.append('club_name', this.updatedClubName);
      form.append('club_description', this.updatedClubDescription);

      if ( this.updatedClubPic ) {
        //console.log('this.updatedClubPic', this.updatedClubPic)
        form.append('club_pic_name', this.updatedClubPic.name);
        form.append('pic', this.updatedClubPic.pngBlob);
      }

      return axios.post("/api/club/update", form)
          .then((/*response*/) => {
            //const clubInfo = response.data;
            this.$router.push({name: 'OscarPoolProfilePage', params: {club_id: this.club_id}});
          })
          .catch(err => {
            console.log('could not update club', err);
          })
          .finally(() => {
            this.updatingClub = false;
          });
    },

    async deleteClub() {
      return this.askForConfirmation(`Are you sure you want to delete this Oscar Pool?`)
          .then(confirmed => {
            if ( !confirmed ) {
              return null;
            }
            return axios.post(`/api/club/mark-for-delete`, {
              club_id: this.club_id,
              mark: true
            });
          })
          .then(response => {
            if ( response ) {
              this.$router.push({name: 'OscarPoolProfilePage', params: {club_id: this.club_id}});
            }
          })
          .catch(err => {
            console.log(err);
          });
    },

    onClubPictureUpdated(_pngBlob) {

      // if there's no blob, the user is clearing the image
      if ( !_pngBlob ) {
        this.updatedClubPic = {
          name: '',
          pngBlob: null
        };
        return;
      }

      // set name and blob
      this.updatedClubPic = {
        name: `${this.club_id}.png`,
        pngBlob: _pngBlob
      };
    }
  }
}
</script>


<style scoped>

.create-club-form {

  color: var(--mol-color-gold);
  background-color: var(--mol-color-gold-background);

  margin-top: 50px;
  padding: 2em;

  border: solid;
  border-width: 1px;
  border-color: var(--mol-color-gold);
  border-radius: 0.375rem;

  .club-pic {
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
  }

  .form-group {
    padding-top: 1.5em;
    padding-bottom: 1.5em;

    button {

    }
  }

  label {
    font-weight: bold;
    margin-bottom: 0.75em;

    .char-limit-text {
      font-weight: normal;
    }
  }
}

.cancel-and-update-buttons {
  .btn {
    width: 8em;
    margin: 5px;
  }
}

.delete-club {

  margin-top: 50px;
  margin-bottom: 50px;

  button {
    display: block;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1em;
  }

  p {
    text-align: center;
    color: var(--mol-color-gold);
  }


}

</style>